/**
 * Method for shallow comparing two objects. This method is useful for React component memoization
 * and mimics the default re-rendering logic in functional components.
 *
 * @see https://reactjs.org/docs/react-api.html#reactmemo
 * @see https://stackoverflow.com/a/22266891
 *
 * @returns {boolean} true if objects are equal (shallow)
 */
export default function shallowCompare(
  a: { [key: string]: any },
  b: { [key: string]: any }
) {
  // eslint-disable-next-line no-restricted-syntax
  for (const key in a) {
    if (!(key in b) || a[key] !== b[key]) {
      return false;
    }
  }
  // eslint-disable-next-line no-restricted-syntax
  for (const key in b) {
    if (!(key in a) || a[key] !== b[key]) {
      return false;
    }
  }
  return true;
}
